import * as React from 'react';
import { observer } from 'mobx-react';
import { SRNotificationHandler, errorIsCancel, IMtsTicketStore, LiveEvents, ProgressStateModel, getSportClassByPresentationId, devLogService } from 'eTip--common';
import { pushToEventDetail } from './../../liveRouting';
import { ProgressContent, InfoMessage } from 'common--design-library';
import { translation } from 'easit--localization';
import { ILiveEventStore } from '../../models/live/liveEvent';
import { EventDetail } from './eventDetailComponent';

export interface IEventDetailRawProps {
    store: ILiveEventStore;
    ticketWrapper: IMtsTicketStore;
    eventId: number; //may be -1 as nothing to show
    canShowInTabs: boolean;
    canShowRemove: boolean;
    remove?: () => void;
    moveToStart?: () => void;
    moveToEnd?: () => void;
    isFavoriteDetail?: boolean;
    isMatchTracker: boolean; //for live only   TODOLS not evaluted when detail only changes
    matchTrackerClick?: () => void; //for live only
    isMatchTrackerAllowed?: boolean;
    canOpenLiveStreamAfterLoad: boolean;
    isLiveStreamAllowed: boolean;
    isDetailInList: boolean; // need to distinguish for unsubscribe. Probably better solution to unsubscribe in store before change of id.
    canClearStoreOnUmount: boolean;
}

@observer
export class EventDetailRawContainer extends React.Component<IEventDetailRawProps, { containerHeight: number }> {

    private mounted: boolean = true;
    private readonly defaultContainerHeight = 350;

    constructor(props: IEventDetailRawProps) {
        super(props);
        this.state = { containerHeight: this.defaultContainerHeight };
    }

    private setMinHeight = (isActionsExpanded: boolean) => {
        this.setState({ containerHeight: (isActionsExpanded ? 200 + this.props.store.apiData?.eventActions?.length * 26 : this.defaultContainerHeight) });
    }

    get store() {
        return this.props.store;
    }

    private eventDetailChangedHandler = (data: { eventId: number, eventData: LiveEvents.EventsItem | null }) => {
        if (!this.mounted) {
            return;
        }

        devLogService.log("liveEventDetailContainer.eventDetailChangedHandler " + data?.eventId + " " + data?.eventData);

        if (data && (data.eventId === this.store.id)) {
            this.store.setData(this.store.id, data.eventData);
        }
    }

    private subscribeForChangesWithClean = (eventId: number, canOpenLiveStreamAfterLoad: boolean): void => {
        /* when using as detail of list:
                - LiveEventStore.openDetail sets a new eventId to store.
                - it's necessary to unsubscribe old=current props.eventId.
                - this.props.eventId is value from store, it's new value
           when using as a detail page
                - this.props.eventId value is read from url.
                - need to unsubscribe value from store
         */
        if (this.store.id > 0 && this.props.eventId !== eventId) {
            const eventIdToUnsubscribe = this.props.isDetailInList ? this.props.eventId : this.store.id;
            this.store.clean(); // for detail page only. When showing detail in list, it's already reset.
            this.unsubscribeFromChanges(eventIdToUnsubscribe);
        }

        this.store.startForNewEvent(eventId);

        if (eventId <= 0) {
            this.store.setNotFound(eventId);
            return;
        }

        let sRNotificationHandler: SRNotificationHandler = this.store.sRNotificationHandler;
        sRNotificationHandler.openingEventDetail(eventId);
        let wasSuccessLiveStreamOpen = false;
        sRNotificationHandler.subscribeForEventDetailAsync(eventId, this.eventDetailChangedHandler)
            .then((eventData: LiveEvents.EventsItem | null) => {
                if (this.store.id === eventId) {
                    this.store.setData(this.store.id, eventData);
                    if (canOpenLiveStreamAfterLoad &&
                        !wasSuccessLiveStreamOpen &&
                        this.store.liveStream &&
                        this.store.liveStream.state === ProgressStateModel.NotInitialized) {

                        this.store.liveStream.prepareUrlsAsync();
                        wasSuccessLiveStreamOpen = true;
                    }
                }
            })
            .catch((reason) => {
                if (errorIsCancel(reason)) {
                    return;
                }
                if (this.store.id === eventId) {
                    this.store.loadFailed(eventId);
                }
            });
    };

    private unsubscribeFromChanges = (eventId: number): void => {
        let sRNotificationHandler: SRNotificationHandler = this.store.sRNotificationHandler;
        sRNotificationHandler.closingEventDetail(eventId);
        sRNotificationHandler.unregisterNotificationHandlerForEventDetail(eventId, this.eventDetailChangedHandler);
        sRNotificationHandler.unsubscribeFromEventDetailAsync(eventId);
    };

    componentWillMount() {
        this.subscribeForChangesWithClean(this.props.eventId, this.props.canOpenLiveStreamAfterLoad);
    }

    componentWillReceiveProps(nextProps: IEventDetailRawProps) {
        if (nextProps.eventId !== this.props.eventId) {
            this.subscribeForChangesWithClean(Number(nextProps.eventId), nextProps.canOpenLiveStreamAfterLoad);

        }
    }

    render() {
        const sportName = this.store.dataIsFilled ? getSportClassByPresentationId(this.props.store.apiData.graphicsPresentationId) : '';
        let linkClassNames = __IsMTSTipos__ ? "masonry-control btn btn-secondary" : "masonry-control btn btn-primary";
        return (<>
            {
                this.props.canShowRemove && this.store.dataIsFilled &&
                <div className={`w-100 d-flex justify-content-between masonry-header ${sportName}-bg ${sportName}-color ${sportName}-border-color`}>
                    <span className="">{this.props.store.apiData.categoryPath}</span>
                    <span className="masonry-header-controls">
                        <a onClick={() => { this.props.moveToStart() }} className={linkClassNames}><span className="fa fa-angle-left"></span></a>
                        <a onClick={() => { this.props.moveToEnd() }} className={linkClassNames}><span className="fa fa-angle-right"></span></a>
                        <a onClick={() => { this.props.remove() }} className={linkClassNames}><span className="fa fa-times"></span></a>
                    </span>
                </div>
            }
            <ProgressContent state={this.store.state}>
                {
                    this.store.dataIsFilled ?
                        <EventDetail
                            detail={this.props.store}
                            ticketWrapper={this.props.ticketWrapper}
                            canShowInTabs={this.props.canShowInTabs}
                            isFavoriteDetail={this.props.isFavoriteDetail}
                            isMatchTracker={this.props.isMatchTracker}
                            matchTrackerClick={this.props.matchTrackerClick}
                            isLiveStreamAllowed={this.props.isLiveStreamAllowed}
                            isMatchTrackerAllowed={this.props.isMatchTrackerAllowed}
                            onGoToEventDetail={() => { pushToEventDetail(this.props.eventId) }}
                            containerHeight={this.state.containerHeight}
                            setContainerHeight={this.setMinHeight}
                        /> :
                        <InfoMessage>
                            {translation().event_no_longer_available}
                            {this.props.canShowRemove && <a onClick={() => { this.props.remove() }} className="masonry-control btn btn-primary"><span className="fa fa-times"></span></a>}
                        </InfoMessage>
                }
            </ProgressContent>
        </>);
    }

    componentWillUnmount() {
        this.mounted = false;

        //clean below is to finish livesttream or matchtracker for statistics. Favorites must call clean for all events in wrapper (store is already detached here)
        if (this.props.canClearStoreOnUmount) {
            this.store.clean();
        }
        this.unsubscribeFromChanges(this.props.eventId);
    }
}

